<script setup>
// VicTech #710:对话清单顶部分页列最前面的「Need human」分页。
// 平时灰字;N ≥ 1 时红字 + 数字(深色主题黄字)。点下去 = 该帐户 label/need-human 清单(全部 agent 可见、open)。
import { computed } from 'vue';
import { needHumanState } from './state';

const props = defineProps({
  active: { type: Boolean, default: false },
  count: { type: Number, default: null },
});
const emit = defineEmits(['select']);

const n = computed(() =>
  props.count === null ? needHumanState.count : props.count
);
const hot = computed(() => n.value > 0);
const TAB_TEXT = 'Need human'; // 与大脑/既有视图同名,暂不进 i18n
</script>

<template>
  <button
    type="button"
    data-test-id="victech-need-human-tab"
    :data-hot="hot ? 'true' : 'false'"
    class="flex-shrink-0 flex items-center select-none cursor-pointer relative px-0 ltr:ml-3 rtl:mr-3 text-sm font-medium after:absolute after:bottom-px after:left-0 after:right-0 after:h-[2px] after:rounded-full after:transition-all after:duration-200"
    :class="[
      hot
        ? 'text-n-ruby-11 dark:text-n-amber-11'
        : 'text-n-slate-10 hover:text-n-slate-12',
      active
        ? 'after:bg-n-brand after:opacity-100'
        : 'after:bg-transparent after:opacity-0',
    ]"
    @click="emit('select')"
  >
    {{ TAB_TEXT }}
    <span
      v-if="hot"
      class="rounded-full h-5 flex items-center justify-center text-xs font-semibold ltr:ml-1 rtl:mr-1 px-1.5 min-w-[20px] bg-n-ruby-9 text-white dark:bg-n-amber-9 dark:text-n-slate-1"
    >
      {{ n }}
    </span>
  </button>
</template>
